import { formatCurrency } from "~/common/utils/currencyFormatter";

export const getPriceLabel = (priceValue: number | undefined, currencyIso: string | undefined, qty: number) => {
  if (qty === 0) {
    return formatCurrency(0, currencyIso);
  }
  if (priceValue === undefined || currencyIso === undefined) {
    return "-";
  }
  return formatCurrency(priceValue, currencyIso);
};
